import { BooleanService } from '@/services/util/BooleanService';
import { Vue } from 'vue-property-decorator';

export default abstract class TrackingCookieService {
  protected abstract cookieName: string;

  public isTrackingAllowed(): boolean {
    return BooleanService.fromString(this.findCookieValue());
  }

  public isCookieSet(): boolean {
    return this.findCookieValue() != null;
  }

  public allowTracking() {
    this.setPreference(true);
  }

  public setPreference(allowTracking: boolean) {
    Vue.prototype.$cookie.set(
      this.cookieName,
      allowTracking,
      {expires: 'Fri, 31 Dec 2099 23:59:59 GMT', SameSite: 'Strict'}
    );
  }


  private findCookieValue(): string | null {
    return Vue.prototype.$cookie.get(this.cookieName);
  }
}
